import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-[#F4EFE6] text-[#2A2825] min-h-[80vh] flex items-center">
      <section className="max-w-2xl mx-auto px-6 md:px-12 py-24 text-center" data-testid="payment-cancel-page">
        <p className="tracking-overline text-xs uppercase text-[#A9724E] mb-4">No worries</p>
        <h1 className="font-serif-display font-light text-3xl sm:text-4xl leading-tight mb-5">Checkout cancelled.</h1>
        <p className="text-[#5E4B3C] leading-relaxed font-body text-lg mb-8">You weren't charged. Whenever you're ready, the Club will be here — and the free 7-day taste is always open too.</p>
        <Link to="/" className="inline-flex items-center gap-2 rounded-full bg-[#A9724E] hover:bg-[#925C3B] text-[#F4EFE6] px-8 py-3.5 text-sm tracking-wide transition-colors duration-500">Back to Outpoured</Link>
      </section>
    </div>
  );
}
